import {
    CustomerSraDepartment,
    CustomerSraDepartmentState,
    CustomerSraDepartmentDetailModel
} from "@teamprevent/common/customerSraDepartment/model";

import componentRoutes from "./components/componentRoutes";
import Base from "./components/Base";
import { customerSraDepartments as reducer } from "./reducer";
import { loadCustomerSraDepartments, loadCustomerSraDepartmentsSuccess } from "./actions";
import * as selectors from "./selectors";
import { CoreDetails } from "./components/details/CoreDetails";
import { customerSraDepartmentApi } from "./customerSraDepartmentApi";

export {
    CustomerSraDepartment,
    CustomerSraDepartmentDetailModel,
    componentRoutes,
    reducer,
    CustomerSraDepartmentState,
    loadCustomerSraDepartments,
    loadCustomerSraDepartmentsSuccess,
    selectors,
    Base,
    CoreDetails,
    customerSraDepartmentApi
};
